<template>
    <svg xmlns="http://www.w3.org/2000/svg" class="e3-svg" :width="Number(size)" :height="Number(size)" viewBox="0 0 24 24">
        <path fill="currentColor" d="M20 14h-6v6h-4v-6H4v-4h6V4h4v6h6v4z"/>
    </svg>
</template>

<script>
export default {
    name: 'PlusThickIcon',
    props: {
        size: {
            type: [String, Number],
            default: 24
        }
    }
};
</script>
